module.exports = __webpack_public_path__ + "static/media/Muli-Light.46b0b797.ttf";